module.exports = __webpack_public_path__ + "img/pausa.b02618de.svg";